/* eslint-disable @typescript-eslint/no-explicit-any */
import { RoutePanel } from '@pbe/react-yandex-maps'
import { yandexMapRouteSetting } from 'feature/addresses/redux/addressCreateSelector'
import { FC, useEffect, useRef } from 'react'
import { useActions, useAppSelector } from 'store/hooks'

// контроллер для карты (построения маршрута)
export const RoutePanelControlUnit: FC = () => {
  const { setRouteSetting, setGeolocationMarkCoords, setStaticMarkCoords } =
    useActions()
  const routeRef = useRef<any>()
  const { from: routeFrom, to: routeTo } = useAppSelector(yandexMapRouteSetting)

  const getRoute = () => {
    const timer = setInterval(() => {
      if (!routeRef.current) return
      const routeControl = routeRef.current
      const routePanel = routeControl.routePanel

      routePanel.state.set({
        fromEnabled: false,
        from: routeFrom,
        to: routeTo,
        type: 'auto',
      })

      routePanel.getRouteAsync().then((multiRoute: any) => {
        multiRoute.model.events.add('requestsuccess', () => {
          setGeolocationMarkCoords(null)
          setStaticMarkCoords(null)
          setRouteSetting({ isLoading: false })
        })
      })
      clearInterval(timer)
    }, 50)
  }

  useEffect(() => {
    if (!routeFrom) return
    if (!routeTo) return
    getRoute()
  }, [routeFrom, routeTo])

  useEffect(() => {
    return () => {
      setRouteSetting({
        from: null,
        to: null,
      })
    }
  }, [])

  return (
    <RoutePanel
      options={{
        visible: false,
      }}
      instanceRef={(inst: any) => {
        if (inst) routeRef.current = inst
      }}
    />
  )
}
